module.exports = __webpack_public_path__ + "static/media/user_account.75756def.svg";